import { render, staticRenderFns } from "./TestingChart.vue?vue&type=template&id=b2a7241a&"
import script from "./TestingChart.vue?vue&type=script&lang=js&"
export * from "./TestingChart.vue?vue&type=script&lang=js&"
import style0 from "./TestingChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports